// Quick Links component - Tools and Manage action buttons for FP Directory
// Note: Evo Platform links (Inspector, Lightspeed, Xero, Skimmer) are now in the table's Evo Platform column

import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Stack, IconButton, Tooltip } from '@mui/material'
import { Edit as EditIcon } from '@mui/icons-material'

import { getResourceIcon } from '../../../utils/resourceIcons'
import { generateAdminFpUrl } from '../../../utils/urls'
import type { FranchisePartner } from '../types'

interface QuickLinksProps {
  fp: FranchisePartner
}

const QuickLinks: React.FC<QuickLinksProps> = ({ fp }) => (
  <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'nowrap', alignItems: 'center' }}>
    {/* Tools Group */}
    <Stack direction="row" spacing={0.5} sx={{ borderRight: '1px solid #e0e0e0', pr: 0.5, mr: 0.5 }}>
      {(fp.resources ?? []).map(resource => {
        const Icon = getResourceIcon(resource.resource_type)
        const url = resource.url
        return (
          <Tooltip
            key={resource.resource_code}
            title={url ? resource.label : `${resource.label} (not configured)`}
          >
            <span>
              <IconButton
                component="a"
                href={url || undefined}
                target="_blank"
                rel="noopener noreferrer"
                size="medium"
                disabled={!url}
                sx={{ opacity: url ? 1 : 0.3 }}
              >
                <Icon size={22} />
              </IconButton>
            </span>
          </Tooltip>
        )
      })}
    </Stack>

    {/* Manage Group */}
    <Tooltip title="Edit in Admin">
      <IconButton
        component={RouterLink}
        to={generateAdminFpUrl(fp.id, 'edit')}
        target="_blank"
        rel="noopener noreferrer"
        size="medium"
      >
        <EditIcon />
      </IconButton>
    </Tooltip>
  </Stack>
)

export default QuickLinks
